/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AcceptPendingDocShareMutationVariables = Types.Exact<{
  input: Types.AcceptDocShareInput;
}>;


export type AcceptPendingDocShareMutation = { acceptDocShare: { __typename: 'AcceptDocShareResult', docId: string, projectId: string } };

export type AcceptPendingDocShare_CreateProjectMutationVariables = Types.Exact<{
  input: Types.ProjectCreateInput;
}>;


export type AcceptPendingDocShare_CreateProjectMutation = { createProject: { __typename: 'ProjectCreateResult', project: { __typename: 'Project', id: string, title: string } } };


export const AcceptPendingDocShareDocument = gql`
    mutation AcceptPendingDocShare($input: AcceptDocShareInput!) {
  acceptDocShare(input: $input) {
    docId
    projectId
  }
}
    `;
export type AcceptPendingDocShareMutationFn = Apollo.MutationFunction<AcceptPendingDocShareMutation, AcceptPendingDocShareMutationVariables>;

/**
 * __useAcceptPendingDocShareMutation__
 *
 * To run a mutation, you first call `useAcceptPendingDocShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptPendingDocShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptPendingDocShareMutation, { data, loading, error }] = useAcceptPendingDocShareMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptPendingDocShareMutation(baseOptions?: Apollo.MutationHookOptions<AcceptPendingDocShareMutation, AcceptPendingDocShareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptPendingDocShareMutation, AcceptPendingDocShareMutationVariables>(AcceptPendingDocShareDocument, options);
      }
export type AcceptPendingDocShareMutationHookResult = ReturnType<typeof useAcceptPendingDocShareMutation>;
export type AcceptPendingDocShareMutationResult = Apollo.MutationResult<AcceptPendingDocShareMutation>;
export type AcceptPendingDocShareMutationOptions = Apollo.BaseMutationOptions<AcceptPendingDocShareMutation, AcceptPendingDocShareMutationVariables>;
export const AcceptPendingDocShare_CreateProjectDocument = gql`
    mutation AcceptPendingDocShare_CreateProject($input: ProjectCreateInput!) {
  createProject(input: $input) {
    project {
      id
      title
    }
  }
}
    `;
export type AcceptPendingDocShare_CreateProjectMutationFn = Apollo.MutationFunction<AcceptPendingDocShare_CreateProjectMutation, AcceptPendingDocShare_CreateProjectMutationVariables>;

/**
 * __useAcceptPendingDocShare_CreateProjectMutation__
 *
 * To run a mutation, you first call `useAcceptPendingDocShare_CreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptPendingDocShare_CreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptPendingDocShareCreateProjectMutation, { data, loading, error }] = useAcceptPendingDocShare_CreateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptPendingDocShare_CreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<AcceptPendingDocShare_CreateProjectMutation, AcceptPendingDocShare_CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptPendingDocShare_CreateProjectMutation, AcceptPendingDocShare_CreateProjectMutationVariables>(AcceptPendingDocShare_CreateProjectDocument, options);
      }
export type AcceptPendingDocShare_CreateProjectMutationHookResult = ReturnType<typeof useAcceptPendingDocShare_CreateProjectMutation>;
export type AcceptPendingDocShare_CreateProjectMutationResult = Apollo.MutationResult<AcceptPendingDocShare_CreateProjectMutation>;
export type AcceptPendingDocShare_CreateProjectMutationOptions = Apollo.BaseMutationOptions<AcceptPendingDocShare_CreateProjectMutation, AcceptPendingDocShare_CreateProjectMutationVariables>;